import * as React from "react"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"

import icon_si from "./../../images/si.svg";
import icon_idea from "./../../images/idea.svg";
import icon_product from "./../../images/product.svg";

interface IProps {
  icon: string
  title: string
  description: string
  bg_color: string
  href_text: string
}

interface IContent {
  href: string
  href_text: string
}


const Item : React.FC<IProps & IContent> = (props) => {
  return (
    <div className="col-sm-6" style={{backgroundColor: props.bg_color}}>
      <Link to={props.href} style={{textDecoration: "none"}}>
        <div className="px-1 py-4 m-0 animation-on-cursor cursor-pointer">
          <img src={props.icon} alt="business-icon" style={{width: "8rem"}} />
          <h5 className="mt-4 mb-2 fw-bold text-dark">{props.title}</h5>
          <small className="text-dark">{props.description}</small>
          <p><small>{props.href_text} &gt;</small></p>
        </div>
      </Link>
    </div>
  )
}

export const Business: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "INDEX.BUSINESS" })

  return (
    <div className="row text-center w-100 mx-auto">
      <div className="col-lg-6 row p-0 m-0" style={{backgroundColor: "#4d770e"}}>
        <div className="col-sm-6 px-0 py-5 m-0 my-auto text-light">
          <h1>BUSINESS</h1>
          <small>{t("SUBTITLE")}</small>
        </div>
        <Item
          icon={icon_si}
          title={t("SYSTEM_INTEGRATION.TITLE")}
          description={t("SYSTEM_INTEGRATION.DESC")}
          bg_color="#E9F2DA"
          href="/services"
          href_text={t("SYSTEM_INTEGRATION.LINK")}
        />
      </div>
      <div className="col-lg-6 row p-0 m-0">
        <Item
          icon={icon_idea}
          title={t("AUTONOMOUS_VEHICLE.TITLE")}
          description={t("AUTONOMOUS_VEHICLE.DESC")}
          href="/autonomous-vehicle"
          href_text={t("AUTONOMOUS_VEHICLE.LINK")}
          bg_color="#F2FAE6"
        />
        <Item
          icon={icon_product}
          title={t("BUSINESS_DEVELOPMENT.TITLE")}
          description={t("BUSINESS_DEVELOPMENT.DESC")}
          bg_color="#FAFFF2"
          href="/products"
          href_text={t("BUSINESS_DEVELOPMENT.LINK")}
        />
      </div>
    </div>
  )
}
